import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { useNavigate, Outlet } from "react-router";
import { Division } from "@ir/ui";
import { AuthConfig } from "@/infrastructure/services/config";
import AuthCheck from "./Auth.check";

const AuthLayout = () => {
  const navigate = useNavigate();
  const { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_REDIRECT_URI, AUTH0_AUDIENCE } = AuthConfig.getInstance();

  const onRedirectCallback = (appState: AppState | undefined) => {
    navigate(appState?.returnTo ?? globalThis.location.pathname);
  };

  if (!(AUTH0_DOMAIN && AUTH0_CLIENT_ID)) {
    return <Division>Oops! Something went wrong.</Division>;
  }

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: AUTH0_REDIRECT_URI,
        audience: AUTH0_AUDIENCE,
        scope: "openid profile email",
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <AuthCheck>
        <Outlet />
      </AuthCheck>
    </Auth0Provider>
  );
};

export default AuthLayout;
